// GENERATED by scripts/generate-icons.js -- do not edit by hand; re-run it
// after using a new icon. Only these icons are bundled.
import {
  faAdd,
  faAreaChart,
  faArrowLeft,
  faArrowUp,
  faBell,
  faBook,
  faBookOpen,
  faCalendarDay,
  faChain,
  faChartColumn,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClockFour,
  faCode,
  faCog,
  faCoins,
  faColumns,
  faCopy,
  faDownload,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExternalLink,
  faFileCode,
  faFileText,
  faFilter,
  faFolderTree,
  faHashtag,
  faHistory,
  faIndustry,
  faInfoCircle,
  faLayerGroup,
  faLightbulb,
  faLineChart,
  faListNumeric,
  faListSquares,
  faMagnifyingGlassChart,
  faMoneyBillTrendUp,
  faNavicon,
  faPercentage,
  faPlusCircle,
  faQuestionCircle,
  faRadiation,
  faRotateForward,
  faSackDollar,
  faSave,
  faSearch,
  faSubtract,
  faSync,
  faSyncAlt,
  faTachometerAltFast,
  faTimes,
  faTrash,
  faUniversity,
  faWallet,
  faWarning,
} from '@fortawesome/free-solid-svg-icons';

export const faIcons = [
  faAdd,
  faAreaChart,
  faArrowLeft,
  faArrowUp,
  faBell,
  faBook,
  faBookOpen,
  faCalendarDay,
  faChain,
  faChartColumn,
  faCheck,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClockFour,
  faCode,
  faCog,
  faCoins,
  faColumns,
  faCopy,
  faDownload,
  faEdit,
  faEnvelope,
  faExclamationCircle,
  faExternalLink,
  faFileCode,
  faFileText,
  faFilter,
  faFolderTree,
  faHashtag,
  faHistory,
  faIndustry,
  faInfoCircle,
  faLayerGroup,
  faLightbulb,
  faLineChart,
  faListNumeric,
  faListSquares,
  faMagnifyingGlassChart,
  faMoneyBillTrendUp,
  faNavicon,
  faPercentage,
  faPlusCircle,
  faQuestionCircle,
  faRadiation,
  faRotateForward,
  faSackDollar,
  faSave,
  faSearch,
  faSubtract,
  faSync,
  faSyncAlt,
  faTachometerAltFast,
  faTimes,
  faTrash,
  faUniversity,
  faWallet,
  faWarning,
];
